module.exports = __webpack_public_path__ + "img/gps_on.bd2da762.svg";